import { ActionSheet, Dialog, Toast } from 'antd-mobile-v5'
import {
  getAfdiPaymentStatus,
  getBasicMermaidPaymentStatus,
  getDmPaymentStatus,
  getEfriPaymentStatus,
  getEFRPublicPaymentStatus,
  getFdiPaymentStatus,
  getMermaidiPaymentStatus,
  getMfdiPaymentStatus,
  getOtherAppsPaymentStatus,
  getOwsiPaymentStatus,
  getSiPaymentStatus,
} from '../../services/api'

export const genderOptions = {
  sc: [
    {
      label: '男',
      value: 'M',
    },
    {
      label: '女',
      value: 'F',
    },
    {
      label: '其他',
      value: 'N',
    },
    {
      label: '保密',
      value: 'P',
    },
  ],
  tc: [
    {
      label: '男',
      value: 'M',
    },
    {
      label: '女',
      value: 'F',
    },
    {
      label: '其他',
      value: 'N',
    },
    {
      label: '保密',
      value: 'P',
    },
  ],
  en: [
    {
      label: 'Male',
      value: 'M',
    },
    {
      label: 'Female',
      value: 'F',
    },
    {
      label: 'Non-conforming',
      value: 'N',
    },
    {
      label: 'Prefer not to say',
      value: 'P',
    },
  ],
}

export const displayGenderLabel = (lang, gender) => {
  const genderList = genderOptions[lang]
  const genderItem = genderList.find((item) => item.value === gender)
  return genderItem ? genderItem.label : ''
}

export const regionOptions = {
  sc: [
    {
      value: 225,
      label: '北京市',
    },
    {
      value: 226,
      label: '天津市',
    },
    {
      value: 227,
      label: '河北省',
    },
    {
      value: 228,
      label: '山西省',
    },
    {
      value: 229,
      label: '内蒙古自治区',
    },
    {
      value: 230,
      label: '辽宁省',
    },
    {
      value: 231,
      label: '吉林省',
    },
    {
      value: 232,
      label: '黑龙江省',
    },
    {
      value: 233,
      label: '上海市',
    },
    {
      value: 234,
      label: '江苏省',
    },
    {
      value: 235,
      label: '浙江省',
    },
    {
      value: 236,
      label: '安徽省',
    },
    {
      value: 237,
      label: '福建省',
    },
    {
      value: 238,
      label: '江西省',
    },
    {
      value: 239,
      label: '山东省',
    },
    {
      value: 240,
      label: '河南省',
    },
    {
      value: 241,
      label: '湖北省',
    },
    {
      value: 242,
      label: '湖南省',
    },
    {
      value: 243,
      label: '广东省',
    },
    {
      value: 244,
      label: '广西壮族自治区',
    },
    {
      value: 245,
      label: '海南省',
    },
    {
      value: 246,
      label: '重庆市',
    },
    {
      value: 247,
      label: '四川省',
    },
    {
      value: 248,
      label: '贵州省',
    },
    {
      value: 249,
      label: '云南省',
    },
    {
      value: 250,
      label: '西藏自治区',
    },
    {
      value: 251,
      label: '陕西省',
    },
    {
      value: 252,
      label: '甘肃省',
    },
    {
      value: 253,
      label: '青海省',
    },
    {
      value: 254,
      label: '宁夏回族自治区',
    },
    {
      value: 255,
      label: '新疆维吾尔自治区',
    },
    {
      value: 256,
      label: '台湾省',
    },
    {
      value: 257,
      label: '香港特别行政区',
    },
    {
      value: 258,
      label: '澳门特别行政区',
    },
  ],
  tc: [
    {
      value: 225,
      label: '北京市',
    },
    {
      value: 226,
      label: '天津市',
    },
    {
      value: 227,
      label: '河北省',
    },
    {
      value: 228,
      label: '山西省',
    },
    {
      value: 229,
      label: '內蒙古自治區',
    },
    {
      value: 230,
      label: '遼寧省',
    },
    {
      value: 231,
      label: '吉林省',
    },
    {
      value: 232,
      label: '黑龍江省',
    },
    {
      value: 233,
      label: '上海市',
    },
    {
      value: 234,
      label: '江蘇省',
    },
    {
      value: 235,
      label: '浙江省',
    },
    {
      value: 236,
      label: '安徽省',
    },
    {
      value: 237,
      label: '福建省',
    },
    {
      value: 238,
      label: '江西省',
    },
    {
      value: 239,
      label: '山東省',
    },
    {
      value: 240,
      label: '河南省',
    },
    {
      value: 241,
      label: '湖北省',
    },
    {
      value: 242,
      label: '湖南省',
    },
    {
      value: 243,
      label: '廣東省',
    },
    {
      value: 244,
      label: '廣西壯族自治區',
    },
    {
      value: 245,
      label: '海南省',
    },
    {
      value: 246,
      label: '重慶市',
    },
    {
      value: 247,
      label: '四川省',
    },
    {
      value: 248,
      label: '貴州省',
    },
    {
      value: 249,
      label: '雲南省',
    },
    {
      value: 250,
      label: '西藏自治區',
    },
    {
      value: 251,
      label: '陝西省',
    },
    {
      value: 252,
      label: '甘肅省',
    },
    {
      value: 253,
      label: '青海省',
    },
    {
      value: 254,
      label: '寧夏回族自治區',
    },
    {
      value: 255,
      label: '新疆維吾爾自治區',
    },
    {
      value: 256,
      label: '台灣省',
    },
    {
      value: 257,
      label: '香港特別行政區',
    },
    {
      value: 258,
      label: '澳門特別行政區',
    },
  ],
  en: [
    {
      value: 225,
      label: 'Beijing',
    },
    {
      value: 226,
      label: 'Tianjin',
    },
    {
      value: 227,
      label: 'Hebei',
    },
    {
      value: 228,
      label: 'Shanxi',
    },
    {
      value: 229,
      label: 'Inner Mongolia',
    },
    {
      value: 230,
      label: 'Liaoning',
    },
    {
      value: 231,
      label: 'Jilin',
    },
    {
      value: 232,
      label: 'Heilongjiang',
    },
    {
      value: 233,
      label: 'Shanghai',
    },
    {
      value: 234,
      label: 'Jiangsu',
    },
    {
      value: 235,
      label: 'Zhejiang',
    },
    {
      value: 236,
      label: 'Anhui',
    },
    {
      value: 237,
      label: 'Fujian',
    },
    {
      value: 238,
      label: 'Jiangxi',
    },
    {
      value: 239,
      label: 'Shandong',
    },
    {
      value: 240,
      label: 'Henan',
    },
    {
      value: 241,
      label: 'Hubei',
    },
    {
      value: 242,
      label: 'Hunan',
    },
    {
      value: 243,
      label: 'Guangdong',
    },
    {
      value: 244,
      label: 'Guangxi',
    },
    {
      value: 245,
      label: 'Hainan',
    },
    {
      value: 246,
      label: 'Chongqing',
    },
    {
      value: 247,
      label: 'Sichuan',
    },
    {
      value: 248,
      label: 'Guizhou',
    },
    {
      value: 249,
      label: 'Yunnan',
    },
    {
      value: 250,
      label: 'Tibet',
    },
    {
      value: 251,
      label: 'Shaanxi',
    },
    {
      value: 252,
      label: 'Gansu',
    },
    {
      value: 253,
      label: 'Qinghai',
    },
    {
      value: 254,
      label: 'Ningxia',
    },
    {
      value: 255,
      label: 'Xinjiang',
    },
    {
      value: 256,
      label: 'Taiwan',
    },
    {
      value: 257,
      label: 'Hong Kong',
    },
    {
      value: 258,
      label: 'Macao',
    },
  ],
}

export const matchLabel = (list, val) => {
  const confirmLabel = list.find((item) => item.value === val)
  return confirmLabel.label
}

// 富友两通道 payType 原生值域（后端 2026-08-17 确认不可合并，按通道拆枚举防误用）：
// H5PAY（公众号内调起）传 pay_type 字段，官方值域 WeJsapiPay/AliPayJL（无 JSAPI）；
// WPOS（PC 扫码）传 order_pay_type 字段，官方值域 WECHAT/ALIPAY。
export const FUIOU_H5_PAY_TYPE = {
  WECHAT_JSAPI: 'WeJsapiPay',
  ALIPAY: 'AliPayJL',
}

export const FUIOU_WPOS_PAY_TYPE = {
  WECHAT: 'WECHAT',
  ALIPAY: 'ALIPAY',
}

// 大陆 Fuiou 支付通道判断: 微信内 → H5PAY; 其余 (PC 浏览器) → WPOS
// 注意：客户端 UA 嗅探仅作为前端 UX 优化，避免无效 API 调用。后端必须独立校验
// 支付通道（payType/channel），不可信任客户端传入的值。
export const pickFuiouChannel = () => {
  if (typeof navigator === 'undefined') return 'WPOS'
  return /MicroMessenger/i.test(navigator.userAgent) ? 'H5PAY' : 'WPOS'
}

export const isFuiouQrChannel = () => pickFuiouChannel() === 'WPOS'

/**
 * 弹出 WPOS 支付渠道选择（微信/支付宝）。
 * 对齐 china-club-web common/fuiou.js 的 pickWposPayType：
 * 原 FAPPLET（聚合码付）需富友小程序权限（5019 已下线），改由用户先选渠道再展示对应单码。
 *
 * @param {Function} formatMessage react-intl 的 formatMessage
 * @returns {{ promise: Promise<'WECHAT'|'ALIPAY'|null>, close: Function }}
 *   promise：用户选择渠道时 resolve 渠道值（值域见 FUIOU_WPOS_PAY_TYPE）；取消/关闭面板时 resolve null
 *   close：组件卸载时调用，清理残留的命令式 ActionSheet
 */
export const createWposPayTypePicker = (formatMessage) => {
  let sheet = null
  // 手动管理 resolve：确保任何退出路径（选渠道/取消/程序化 close）promise 都必被 settle，不悬挂
  let resolveFn = null
  const settle = (value) => {
    if (resolveFn) {
      resolveFn(value)
      resolveFn = null
    }
  }
  const promise = new Promise((resolve) => {
    resolveFn = resolve
    sheet = ActionSheet.show({
      actions: [
        { text: formatMessage({ id: 'fuiou-pay-channel-wechat' }), key: FUIOU_WPOS_PAY_TYPE.WECHAT },
        { text: formatMessage({ id: 'fuiou-pay-channel-alipay' }), key: FUIOU_WPOS_PAY_TYPE.ALIPAY },
      ],
      closeOnAction: true,
      onAction: (action) => settle(action.key),
      onClose: () => settle(null),
    })
  })
  return {
    promise,
    close: () => {
      if (sheet) {
        sheet.close()
        sheet = null
      }
      // 兜底：程序化 close 若未触发 onClose 回调，也要保证 promise 不悬挂
      settle(null)
    },
  }
}

// 富友支付重定向域名白名单
// fuyou.com 已移除：后端核对确认（2026-08-15）所有网关仅使用 fuioupay.com，代码与配置零使用 fuyou.com，
const FUIOU_ALLOWED_DOMAINS = ['fuiou.com', 'fuioupay.com']

/**
 * 验证支付重定向 URL 是否属于富友受信域名，防止开放重定向攻击。
 * @param {string} url 后端返回的支付 URL
 * @returns {boolean} 是否为合法的富友支付 URL
 */
export const isValidFuiouUrl = (url) => {
  if (!url) return false
  try {
    const parsed = new URL(url)
    if (parsed.protocol !== 'https:') return false
    return FUIOU_ALLOWED_DOMAINS.some((domain) => parsed.hostname === domain || parsed.hostname.endsWith('.' + domain))
  } catch {
    return false
  }
}

/**
 * 验证 WPOS 单码（ALIPAY/WECHAT）返回的二维码内容。
 * <p>
 * 该值只被本地编码成二维码图片展示（不跳转、不发起请求），
 * 因此校验仅做形态白名单，防止后端返回异常内容被编码展示：
 * 支付宝为 https://qr.alipay.com/*，微信为 weixin://wxpay/bizpayurl*，
 * 历史 FAPPLET 形态仍为富友域名，统一复用 isValidFuiouUrl。
 * @param {string} value 后端返回的二维码内容
 * @returns {boolean} 是否为合法的扫码支付二维码内容
 */
export const isValidWposQrContent = (value) => {
  // 先挡非字符串：后端契约漂移（返回对象/数字）时 startsWith 会抛 TypeError，
  // MemberRenew/StoreRenew 的 effect 内调用无保护，会挂掉整页
  if (typeof value !== 'string' || !value) return false
  try {
    const parsed = new URL(value)
    // 精确域名匹配而非字符串前缀匹配：https://qr.alipay.com.evil.com/pay 之类
    // 钓鱼域名不得通过（前缀匹配会把它们误判为合法支付宝收款码）
    if (parsed.protocol === 'https:' && parsed.hostname === 'qr.alipay.com') return true
    // 微信扫码形态 weixin://wxpay/bizpayurl...：protocol 与 host 全等，pathname 限前缀
    if (parsed.protocol === 'weixin:' && parsed.hostname === 'wxpay' && parsed.pathname.startsWith('/bizpayurl'))
      return true
  } catch {
    // 非标准 URL（解析失败）落下方富友域名兜底
  }
  return isValidFuiouUrl(value)
}

/**
 * 安全跳转到富友支付页面。先验证 URL 属于富友受信域名，通过后再执行 redirect。
 * 验证失败时展示 Toast 错误提示，不执行跳转。
 * @param {string} url 后端返回的支付 URL
 * @param {string} errorMessage 验证失败时展示的错误信息
 * @returns {boolean} 是否成功跳转
 */
export const safeFuiouRedirect = (url, errorMessage) => {
  if (!isValidFuiouUrl(url)) {
    Toast.show({ icon: 'fail', content: errorMessage || '支付地址异常，请稍后重试' })
    return false
  }
  window.location.replace(url)
  return true
}

/**
 * 非富友链接（海外 Stripe/TradeVan 等）跳转前校验：只放行 https 绝对地址
 * （支付类跳转不降级到明文 http，与 isValidFuiouUrl 的 https-only 保持一致），
 * 拦截 javascript: 等危险协议和畸形值，堵住白名单之外的 fail-open 跳转。
 * @param {string} url 后端返回的支付 URL
 * @param {string} errorMessage 校验失败时展示的错误信息
 * @returns {boolean} 是否成功跳转
 */
const isValidHttpUrl = (url) => {
  if (!url) return false
  try {
    const parsed = new URL(url)
    return parsed.protocol === 'https:'
  } catch {
    return false
  }
}

// 海外支付渠道域名白名单（后缀匹配，与 FUIOU_ALLOWED_DOMAINS 同款校验）：
// 白名单外的域名弹确认再跳转，防后端响应被污染时静默跳任意 https 钓鱼收款页
const EXTERNAL_ALLOWED_DOMAINS = ['stripe.com', 'tradevan.com.tw']

export const safeExternalRedirect = (url, errorMessage, confirmTexts) => {
  if (!isValidHttpUrl(url)) {
    Toast.show({ icon: 'fail', content: errorMessage || '支付地址异常，请稍后重试' })
    return false
  }
  const parsed = new URL(url)
  const isAllowed = EXTERNAL_ALLOWED_DOMAINS.some(
    (domain) => parsed.hostname === domain || parsed.hostname.endsWith('.' + domain)
  )
  if (isAllowed) {
    window.location.replace(url)
    return true
  }
  if (!confirmTexts) {
    // 未提供确认文案时保守拦截（不静默跳转白名单外域名）
    Toast.show({ icon: 'fail', content: errorMessage || '支付地址异常，请稍后重试' })
    return false
  }
  Dialog.confirm({
    content: confirmTexts.message(parsed.hostname),
    confirmText: confirmTexts.confirm,
    cancelText: confirmTexts.cancel,
    onConfirm: () => window.location.replace(url),
  })
  return true
}

// 走 Fuiou (大陆) 新支付通道的申请类型
export const FUIOU_PAY_TYPES = [
  'MEMBER_APPLICATION_EFRI',
  'MEMBER_APPLICATION_FDI',
  'MEMBER_APPLICATION_AFDI',
  'MEMBER_APPLICATION_MFDI',
  'MEMBER_APPLICATION_DM',
  'MEMBER_APPLICATION_SI',
  'MEMBER_APPLICATION_OWSI',
  'MEMBER_APPLICATION_PADI_MERMAID_I',
  'MEMBER_APPLICATION_PADI_BASIC_MERMAID_I',
  'MEMBER_APPLICATION_OTHER',
  'EFRP',
]

// PC 扫码轮询时，按申请类型查对应 paymentStatus 接口检测支付完成。
// 统一走轻量 paymentStatus 端点，不用重型 detail 接口做 3s 轮询。
export const PAY_TYPE_DETAIL_FN = {
  MEMBER_APPLICATION_EFRI: getEfriPaymentStatus,
  MEMBER_APPLICATION_FDI: getFdiPaymentStatus,
  MEMBER_APPLICATION_AFDI: getAfdiPaymentStatus,
  MEMBER_APPLICATION_MFDI: getMfdiPaymentStatus,
  MEMBER_APPLICATION_DM: getDmPaymentStatus,
  MEMBER_APPLICATION_SI: getSiPaymentStatus,
  MEMBER_APPLICATION_OWSI: getOwsiPaymentStatus,
  MEMBER_APPLICATION_PADI_MERMAID_I: getMermaidiPaymentStatus,
  MEMBER_APPLICATION_PADI_BASIC_MERMAID_I: getBasicMermaidPaymentStatus,
  MEMBER_APPLICATION_OTHER: getOtherAppsPaymentStatus,
  EFRP: getEFRPublicPaymentStatus,
}

export const isApplicationPaymentPaid = (data) => Boolean(data && data.paid === true)
